import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import Table from '../../../common/Table';
import { BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHER_COLUMNS } from '../../../../config/columns';
import {
  getBankReconciliationCorporateManualVouchers,
  clearBankReconciliationCorporateManualVouchers,
} from '../../../../actions';
import BankReconciliationManualVoucherPaymentsTable from './BankReconciliationManualVoucherPaymentsTable';

const BankReconciliationCorporateManualVouchersTable = ({
  date,
  holderType,
  corporateId,
  currency,
  businessName,
  manualVouchers,
  loading,
  dispatchGetBankReconciliationCorporateManualVouchers,
  dispatchClearBankReconciliationCorporateManualVouchers,
}) => {
  const corporate = useMemo(
    () => ({ date, holderType, corporateId, currency }),
    [date, holderType, corporateId, currency],
  );

  useEffect(() => {
    dispatchGetBankReconciliationCorporateManualVouchers(corporate);

    return () =>
      dispatchClearBankReconciliationCorporateManualVouchers(corporate);
  }, [corporate]);

  const data = useMemo(() => manualVouchers.toJS(), [manualVouchers]);

  const renderPaymentsTable = ({
    original: { manualVoucherId, documentSeries, documentCode },
  }) => (
    <BankReconciliationManualVoucherPaymentsTable
      manualVoucherId={manualVoucherId}
      documentName={
        documentSeries || documentCode
          ? `${documentSeries || '-'}-${documentCode || '-'}`
          : String(manualVoucherId)
      }
      corporate={corporate}
    />
  );

  return (
    <div className="p-3 pl-5 bg-white">
      <h6 className="text-muted">
        Comprobantes manuales de {businessName || corporateId}
        {currency ? ` (${currency})` : ''}
      </h6>
      <Table
        columns={BANK_RECONCILIATION_CORPORATE_MANUAL_VOUCHER_COLUMNS}
        data={data}
        loading={loading}
        manual={false}
        showPagination={false}
        pageSize={data.length || 1}
        groupedColumns
        collapseOnDataChange={false}
        rowComponent={renderPaymentsTable}
      />
    </div>
  );
};

BankReconciliationCorporateManualVouchersTable.propTypes = {
  date: PropTypes.string.isRequired,
  holderType: PropTypes.string.isRequired,
  corporateId: PropTypes.number.isRequired,
  currency: PropTypes.string,
  businessName: PropTypes.string,
  manualVouchers: PropTypes.instanceOf(Immutable.List).isRequired,
  loading: PropTypes.bool,
  dispatchGetBankReconciliationCorporateManualVouchers:
    PropTypes.func.isRequired,
  dispatchClearBankReconciliationCorporateManualVouchers:
    PropTypes.func.isRequired,
};

BankReconciliationCorporateManualVouchersTable.defaultProps = {
  currency: null,
  businessName: null,
  loading: false,
};

const mapStateToProps = (
  { SalesUnit },
  { date, holderType, corporateId, currency },
) => {
  const path = [
    'manualVouchersByCorporate',
    date,
    holderType,
    corporateId,
    currency,
  ];

  return {
    manualVouchers:
      SalesUnit.BankReconciliation.getIn([...path, 'content']) ||
      Immutable.List(),
    loading: SalesUnit.BankReconciliation.getIn([...path, 'loading']) || false,
  };
};

const mapDispatchToProps = {
  dispatchGetBankReconciliationCorporateManualVouchers:
    getBankReconciliationCorporateManualVouchers,
  dispatchClearBankReconciliationCorporateManualVouchers:
    clearBankReconciliationCorporateManualVouchers,
};

export { BankReconciliationCorporateManualVouchersTable };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BankReconciliationCorporateManualVouchersTable);
